import React from "react";
import { strings } from "../../Translations/strings";

const Toc = () => {
  return <p className="toc-text">{strings.toc_text}</p>;
};

export default Toc;
